<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 banner-section"
        :style="{
          backgroundImage: `url(${imgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }"
      >
        <div class="banner-content text-left">

          <b-img
              height="50px"
              class="mb-1"
              :src="require('@/assets/images/logo/TaskFino logo white.png')"
              alt="TaskFino"
          />

          <h1 class="banner-title text-white">
            All-in-One Office<br>
            Management Software
          </h1>
          <p class="banner-description text-white mb-0">
            Save One Week Every Month
          </p>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <template>
            <button
              v-if="showInstallButton"
              class="pwa-install-btn btn btn-primary"
              @click="installPwa"
            >
              Install App
            </button>
          </template>
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Welcome to {{ appTitle }}
          </b-card-title>
          <b-card-text class="mb-2">
            Please login to your account
          </b-card-text>

          <b-alert
            v-if="isCredentialsShow"
            variant="primary"
            show
          >

            <div class="alert-body font-small-2">

              <p>
                <small class="mr-50"><span class="font-weight-bold">Email: </span>demo@taskfino.com</small>
              </p>
              <p>
                <small class="mr-50"><span class="font-weight-bold">Password: </span>BestOfficeManagementTool</small>
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'Use this login credentials only for the demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                  vid="email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="email"
                    :state="errors.length > 0 ? false : null"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- loading button -->
              <template v-if="isLoading">
                <b-button
                  variant="primary"
                  block
                  disabled
                >
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>

              <!-- submit button -->
              <template v-else>
                <b-button
                  type="submit"
                  variant="primary"
                  block
                >
                  Login
                </b-button>
              </template>
            </b-form>
          </validation-observer>

          <template v-if="!isCredentialsShow">

            <div class="text-center font-weight-bold my-1">
              OR
            </div>

            <div
              id="googleSignInButton"
              class="mb-2 d-flex justify-content-center"
            />
          </template>

          <b-alert
            class="mt-2"
            variant="primary"
            show
          >
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Note:</span> Empowering your business with an all-in-one solution that drives efficiency.</small>
              </p>

            </div>

          </b-alert>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'page-auth-register-v2' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">or</div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { DASHBOARD_ACCESS } from '@/helpers/permissionsConstant'
import { computed } from '@vue/composition-api'
import { requestNotificationPermission, onMessage, messaging } from '@/firebase'

export default {
  name: 'LoginView',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BAlert,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      status: '',
      password: '',
      email: '',
      sideImg: require('@/assets/images/pages/TaskFino-Login-page.jpg'),
      isLoading: false,
      isCredentialsShow: false,
      deferredPrompt: null,
      showInstallButton: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/TaskFino-Login-page-old.jpg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  watch: {
    isCredentialsShow(newVal) {
      if (newVal) {
        this.email = 'demo@taskfino.com'
        this.password = 'BestOfficeManagementTool'
      } else {
        this.email = ''
        this.password = ''
      }
    },
  },

  async created() {
    this.isCredentialsShow = process.env.VUE_APP_DEMO_CREDENTIALS_SHOW
  },

  mounted() {
    console.log('Adding beforeinstallprompt listener')

    window.addEventListener('beforeinstallprompt', e => {
      console.log('beforeinstallprompt event fired')
      e.preventDefault()
      this.deferredPrompt = e
      this.showInstallButton = true
    })

    if (window.matchMedia('(display-mode: standalone)').matches) {
      console.log('Already running as PWA')
      this.showInstallButton = false
    }

    window.handleCredentialResponse = response => {
      const googleToken = response.credential
      this.handleGoogleLoginToken(googleToken)
    }

    const loadGoogle = () => {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        window.google.accounts.id.initialize({
          client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          callback: window.handleCredentialResponse,
        })

        window.google.accounts.id.renderButton(
          document.getElementById('googleSignInButton'),
          {
            theme: 'outline',
            size: 'large',
            type: 'standard',
          },
        )
      } else {
        setTimeout(loadGoogle, 100)
      }
    }

    loadGoogle()
  },

  methods: {
    async installPwa() {
      // Show the install prompt
      this.deferredPrompt.prompt()
      // Wait for the user to respond to the prompt
      const { outcome } = await this.deferredPrompt.userChoice
      // Optionally, send analytics event with outcome of user choice
      console.log(`User response to the install prompt: ${outcome}`)
      // We've used the prompt, and can't use it again, throw it away
      this.deferredPrompt = null
      // Hide the install button regardless of outcome
      this.showInstallButton = false
    },

    async updateCompanyLogoInStore() {
      const resCompany = await this.$api.get('/api/companies/current')

      if (resCompany) {
        await this.$store.dispatch('authModule/setCompanyLogo', {
          companyLogo: resCompany?.data?.data?.logo,
        })
      }
    },
    async validationForm() {
      this.$refs.loginValidation.validate().then(async success => {
        if (success) {
          try {
            this.isLoading = true
            // for login
            const resLogin = await this.$api.post('/api/login', {
              email: this.email,
              password: this.password,
            })

            const data = resLogin?.data

            await this.$store.dispatch('authModule/setIsAuthenticated', {
              isAuthenticated: true,
              token: data?.access_token,
              refreshToken: data?.refresh_token,
            })

            const token = await requestNotificationPermission()

            if (token) {
              this.$api.post('/api/save-fcm-token', {
                token,
                device_info: navigator.userAgent,
                is_pwa: window.matchMedia('(display-mode: standalone)').matches,
              })
                .then(() => console.log('Token sent to backend'))
                .catch(e => console.error('Error sending token to backend', e))
            } else {
              console.warn('No token received')
            }

            const settings = await this.$api.get('/api/settings')
            store.commit('app/setGlobalDateFormat', settings?.data?.data?.date_format)

            // update company logo
            await this.updateCompanyLogoInStore()

            // reset all filters from state manager after login
            store.dispatch('allTaskModule/resetFilters')
            store.dispatch('globalTrackerModule/resetFilters')
            store.dispatch('boardModule/resetFilters')

            // get user
            const resUser = await this.$api.post(
              '/api/user?include=permissions,designation,roles,department',
            )

            const { permissions, ...user } = resUser?.data?.data
            const mapPermissions = permissions?.data.map(item => item.name)

            await this.$store.dispatch('userModule/setUser', {
              user,
            })

            await this.$store.dispatch('userModule/setPermissions', {
              permissions: mapPermissions,
            })

            const paymentMethod = await this.$api.get(
              `/api/company-payment-method/${user.id}`,
            )

            await this.$store.dispatch('paymentMethodModule/setPaymentMethod', {
              paymentMethod: paymentMethod?.data,
            })

            let routeName = 'admin-dashboard'

            if (mapPermissions.includes(DASHBOARD_ACCESS)) {
              routeName = 'admin-dashboard'
            }

            this.$router.replace({ name: routeName }).then(() => {
              this.isLoading = false
              window.location.reload()
            })
          } catch (error) {
            this.isLoading = false

            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: error?.response?.data?.message,
                },
              })
            }

            if (error?.response?.data?.errors) {
              this.$refs.loginValidation.setErrors(
                error?.response?.data?.errors,
              )
            }
          }
        }
      })
    },

    async handleGoogleLoginToken(googleCredential) {
      try {
        this.isLoading = true

        const resLogin = await this.$api.post('/api/auth/google/callback', {
          token: googleCredential,
        })

        const data = resLogin?.data

        await this.$store.dispatch('authModule/setIsAuthenticated', {
          isAuthenticated: true,
          token: data?.access_token,
          refreshToken: data?.refresh_token,
        })

        const settings = await this.$api.get('/api/settings')
        store.commit('app/setGlobalDateFormat', settings?.data?.data?.date_format)

        await this.updateCompanyLogoInStore()

        store.dispatch('allTaskModule/resetFilters')
        store.dispatch('globalTrackerModule/resetFilters')
        store.dispatch('boardModule/resetFilters')

        const resUser = await this.$api.post(
          '/api/user?include=permissions,designation,roles,department',
        )

        const { permissions, ...user } = resUser?.data?.data
        const mapPermissions = permissions?.data.map(item => item.name)

        await this.$store.dispatch('userModule/setUser', { user })
        await this.$store.dispatch('userModule/setPermissions', {
          permissions: mapPermissions,
        })

        const paymentMethod = await this.$api.get(
          `/api/company-payment-method/${user.id}`,
        )

        await this.$store.dispatch('paymentMethodModule/setPaymentMethod', {
          paymentMethod: paymentMethod?.data,
        })

        let routeName = 'admin-dashboard'

        if (mapPermissions.includes(DASHBOARD_ACCESS)) {
          routeName = 'admin-dashboard'
        }

        this.$router.replace({ name: routeName }).then(() => {
          this.isLoading = false
          window.location.reload()
        })
      } catch (error) {
        this.isLoading = false

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            variant: 'danger',
            text: error?.response?.data?.message || 'Google login failed',
          },
        })
      }
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.pwa-install-btn {
  /* Style your button as needed */
  padding: 8px 16px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  position: fixed;
  top: 10px;
  right: 10px;
}

.banner-section {
  position: relative;
  min-height: 100vh;

  .banner-content {
    max-width: 800px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #fff;
  }

  .banner-logo {
    width: 100px;
    height: auto;
  }

  .banner-title {
    font-size: 4rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  .banner-description {
    font-size: 1.5rem;
    font-weight: 400;
  }

  /* Make responsive for smaller screens */
  @media (max-width: 1200px) {
    .banner-title {
      font-size: 2rem;
    }
    .banner-description {
      font-size: 1rem;
    }
  }

  @media (max-width: 992px) {
    display: none !important; // hides banner on small screens (keeps login visible)
  }
}

</style>
